import { render, staticRenderFns } from "./MakeupSchedulersPage.vue?vue&type=template&id=d89d0ffa&scoped=true&lang=pug"
import script from "./MakeupSchedulersPage.vue?vue&type=script&lang=js"
export * from "./MakeupSchedulersPage.vue?vue&type=script&lang=js"
import style0 from "./MakeupSchedulersPage.vue?vue&type=style&index=0&id=d89d0ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89d0ffa",
  null
  
)

export default component.exports